import Map from 'components/Map/Map';
import ExecutiveSummaryCard from '../ExecutiveSummaryCard/ExecutiveSummaryCard';
import { Section as CardSection } from '../ExecutiveSummaryCard/types';
import { MapPoint } from '../types';

export interface ExecutiveSummaryDetailProps {
    sections: CardSection[];
    map: MapPoint | null;
}

const ExecutiveSummaryDetail = ({ sections, map }: ExecutiveSummaryDetailProps) => (
    <div className="d-flex justify-content-between align-items-stretch mb-3">
        <ExecutiveSummaryCard containerClassName={map ? 'w-50 mr-1' : 'w-100'} sections={sections} />
        {map && (
            <div className="ml-1 w-50 d-flex position-relative">
                <Map lat={map.lat} lng={map.lng} height="100%" />
            </div>
        )}
    </div>
);

export default ExecutiveSummaryDetail;
